const ru: Record<string, string> = {
  'app.name': 'Greek Notebook',
  'app.tagline': 'Тетрадь для письменного греческого A2',
  'common.loading': 'Загрузка…',
  'common.retry': 'Повторить',
  'common.cancel': 'Отмена',
  'common.close': 'Закрыть',
  'common.save': 'Сохранить',
  'common.delete': 'Удалить',
  'common.back': 'Назад',
  'common.continue': 'Продолжить',
  'common.start': 'Начать',
  'common.open': 'Открыть',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.search': 'Поиск',
  'common.all': 'Все',
  'common.more': 'Ещё',
  'common.loadMore': 'Показать ещё',
  'common.empty': 'Здесь пока пусто',
  'common.words': 'слов',
  'common.minutes': 'мин',
  'common.copy': 'Копирование',
  'common.recall': 'Воспроизведение',
  'common.free': 'Свободное письмо',
  'common.exam': 'Экзамен',
  'common.drill': 'Повтор',
  'common.informal': 'Неформальное',
  'common.formal': 'Формальное',
  'common.semi_formal': 'Полуформальное',
  'common.practiceScore': 'Учебная оценка — не официальный экзаменационный балл',
  'common.unverified': 'Не проверено преподавателем',
  'common.aiDraft': 'AI-черновик',
  'common.original': 'Оригинальный материал',
  'common.official': 'Официальный образец',
  'common.signOut': 'Выйти',
  'common.offline': 'Нет сети',
  'common.readOnly': 'Только просмотр',
  'common.copyToClipboard': 'Скопировать',
  'state.draft': 'Черновик',
  'state.submitted': 'Отправлено',
  'state.transcribing': 'Распознаём почерк',
  'state.transcription_failed': 'Ошибка распознавания',
  'state.awaiting_confirmation': 'Проверьте текст',
  'state.evaluating': 'Оцениваем',
  'state.evaluation_failed': 'Ошибка оценки',
  'state.evaluated': 'Готово',
  'topic.friends_family_invitations': 'Друзья, семья, приглашения',
  'topic.holidays_travel': 'Отдых и путешествия',
  'topic.school_language_classes': 'Учёба и языковые курсы',
  'topic.requests_appointments_information': 'Запросы, записи, информация',
  'topic.workplace_everyday_admin': 'Работа и быт',
  'topic.complaints_incidents': 'Жалобы и происшествия',
};
const en: Record<string, string> = {
  'app.name': 'Greek Notebook',
  'app.tagline': 'A notebook for A2 written Greek',
  'common.loading': 'Loading…',
  'common.retry': 'Retry',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.back': 'Back',
  'common.continue': 'Continue',
  'common.start': 'Start',
  'common.open': 'Open',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.search': 'Search',
  'common.all': 'All',
  'common.more': 'More',
  'common.loadMore': 'Load more',
  'common.empty': 'Nothing here yet',
  'common.words': 'words',
  'common.minutes': 'min',
  'common.copy': 'Copy',
  'common.recall': 'Recall',
  'common.free': 'Free writing',
  'common.exam': 'Exam',
  'common.drill': 'Drill',
  'common.informal': 'Informal',
  'common.formal': 'Formal',
  'common.semi_formal': 'Semi-formal',
  'common.practiceScore': 'Practice score — not an official exam grade',
  'common.unverified': 'Not reviewed by a teacher',
  'common.aiDraft': 'AI draft',
  'common.original': 'Original material',
  'common.official': 'Official sample',
  'common.signOut': 'Sign out',
  'common.offline': 'Offline',
  'common.readOnly': 'Read only',
  'common.copyToClipboard': 'Copy',
  'state.draft': 'Draft',
  'state.submitted': 'Submitted',
  'state.transcribing': 'Reading handwriting',
  'state.transcription_failed': 'Recognition failed',
  'state.awaiting_confirmation': 'Check the text',
  'state.evaluating': 'Evaluating',
  'state.evaluation_failed': 'Evaluation failed',
  'state.evaluated': 'Done',
  'topic.friends_family_invitations': 'Friends, family, invitations',
  'topic.holidays_travel': 'Holidays & travel',
  'topic.school_language_classes': 'School & language classes',
  'topic.requests_appointments_information': 'Requests & appointments',
  'topic.workplace_everyday_admin': 'Work & everyday admin',
  'topic.complaints_incidents': 'Complaints & incidents',
};
export default { ru, en };
